<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license. See LICENSE.md in the
project root for license information.
-->

<div class="enchilada">
  <div class="team-list-container elevate">
    <div class="team-list-header">
      <div class="header-icon-div center-self">
        <mat-icon class="mdi-24px header-icon" fontIcon="mdi-account-multiple"></mat-icon>
        MSEL Teams
      </div>
      <div class="search-div">
        <mat-form-field style="width: 75%; margin-left:10%;">
          <input matInput [(ngModel)]="filterString" (ngModelChange)="applyFilter($event)"
            placeholder="Search" />
          @if (filterString) {
          <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
            <mat-icon style="transform: scale(0.85)" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
      </div>
    </div>
    <hr />

    @if (teamDataSource.filteredData.length > 0) {
    <mat-table class="mat-table-msel-teams" #table [dataSource]="teamDataSource" matSort>
      <ng-container matColumnDef="name">
        <mat-cell *matCellDef="let element">
          @if (element.shortName) {
          <div>{{ element.shortName }}</div>
          }
          @if (!element.shortName && element.name) {
          <div>{{ element.name }}</div>
          }
          @if (!element.shortName && !element.name) {
          <div>{{ element.id }}</div>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="id">
        <mat-cell *matCellDef="let element">
          <div>
            <button mat-icon-button (click)="addTeamToCard(element)" title="Add {{ element.name }}"
              [disabled]="!canEditMsel()">
              <mat-icon class="mdi-18px" fontIcon="mdi-plus-circle-outline" title="Add {{ element.name }}"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <mat-row *matRowDef="let row; columns: mselTeamColumns"></mat-row>
    </mat-table>
    }
    @if (teamDataSource.filteredData.length === 0) {
    <div>No teams found</div>
    }
  </div>

  <div class="card-list-container elevate">
    @if (false) {
    <mat-card appearance="outlined" style="display: flex; justify-content: center; align-items: center;">
      <mat-progress-spinner color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </mat-card>
    }

    <mat-table class="mat-table-card-teams" #table [dataSource]="cardTeamDataSource" matSort>
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef>
          <mat-icon class="mdi-24px header-icon" fontIcon="mdi-account-group"></mat-icon>
          Card Teams
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>{{ getTeamShortName(element.teamId) }}</div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="isShownOnWall">
        <mat-header-cell *matHeaderCellDef>Is Shown</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="element.isShownOnWall" (change)="setIsShownOnWall(element, $event.checked)"
            [disabled]="!canEditMsel()"></mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="canPostArticles">
        <mat-header-cell *matHeaderCellDef>Can Post</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <mat-checkbox [checked]="element.canPostArticles" (change)="setCanPostArticles(element, $event.checked)"
            [disabled]="!canEditMsel()"></mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef aria-label="Actions"></mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            <button mat-icon-button (click)="removeTeamFromCard(element.id)" title="Remove {{ element.name }}"
              [disabled]="!canEditMsel()">
              <mat-icon class="mdi-18px" fontIcon="mdi-minus-circle-outline"
                title="Remove {{ element.name }}"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="cardTeamColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: cardTeamColumns"></mat-row>
    </mat-table>

  </div>
</div>
